"use client";

import {
	FeaturedText,
	type FeaturedTextProps
} from "@pamperedchef/design-system";

import * as styles from "./OfferHeroView.module.scss";

export interface OfferHeroViewProps {
	/** Hero's eyebrow */
	eyebrow?: string;
	/** Hero's headline */
	headline: string;
	/** Hero's headline style */
	headlineStyle?: FeaturedTextProps["styledAs"];
	/** Hero's theme */
	theme: FeaturedTextProps["theme"];
	/** Heading Tag */
	headlineTag?: FeaturedTextProps["headingTag"];
}

/**
 * Offer Hero
 */
export function OfferHeroView({
	eyebrow,
	headline,
	headlineStyle = "display-sm",
	theme,
	headlineTag = "h1"
}: OfferHeroViewProps): JSX.Element {
	return (
		<div className={styles["offer-hero"]}>
			<FeaturedText
				className={styles["title"]}
				eyebrow={eyebrow}
				headline={headline}
				styledAs={headlineStyle}
				theme={theme}
				headingTag={headlineTag}
			/>
		</div>
	);
}
